'use client';

import type { Footer, Header } from '@dobrozem/cms';
import { client } from '@dobrozem/sdk';
import type { PropsWithChildren } from 'react';
import { createContext, useContext, useState } from 'react';
client.setConfig({
  baseUrl: process.env.NEXT_PUBLIC_CORE_URL,
  credentials: 'include'
});
const GlobalsContext = createContext<{
  footer: Footer;
  header: Header;
  setShowConsultationModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowContactSupportModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowInDevelopmentModal: React.Dispatch<React.SetStateAction<boolean>>;
  showConsultationModal?: boolean;
  showContactSupportModal?: boolean;
  showInDevelopmentModal?: boolean;
} | null>(null);
export const useGlobals = () => {
  const globals = useContext(GlobalsContext);
  if (globals === null) {
    throw new Error('useGlobals must be used within a GlobalsProvider');
  }
  return globals;
};
type Props = {
  footer: Footer;
  header: Header;
};
export const GlobalsProivder = ({
  children,
  footer,
  header
}: PropsWithChildren<Props>) => {
  const [showInDevelopmentModal, setShowInDevelopmentModal] = useState(false);
  const [showConsultationModal, setShowConsultationModal] = useState(false);
  const [showContactSupportModal, setShowContactSupportModal] = useState(false);
  return <GlobalsContext.Provider value={{
    footer,
    header,
    setShowConsultationModal,
    setShowContactSupportModal,
    setShowInDevelopmentModal,
    showConsultationModal,
    showContactSupportModal,
    showInDevelopmentModal
  }} data-sentry-element="unknown" data-sentry-component="GlobalsProivder" data-sentry-source-file="GlobalsContext.tsx">
      {children}
    </GlobalsContext.Provider>;
};